import { FiCheck } from 'react-icons/fi'
import './passwordChecklist.css'

// Mesmas regras de backend/controllers/UserController.js validatePassword —
// se uma mudar lá, replicar aqui também.
const RULES = [
    { key: 'length', label: 'Pelo menos 8 caracteres', test: (p) => p.length >= 8 },
    { key: 'lower', label: 'Uma letra minúscula', test: (p) => /[a-z]/.test(p) },
    { key: 'upper', label: 'Uma letra maiúscula', test: (p) => /[A-Z]/.test(p) },
    { key: 'number', label: 'Um número', test: (p) => /[0-9]/.test(p) },
    { key: 'special', label: 'Um caractere especial (!@#$%^&*)', test: (p) => /[!@#$%^&*]/.test(p) },
]

function PasswordChecklist({ password }) {
    const value = password || ''

    return (
        <ul className="password-checklist">
            {RULES.map((rule) => {
                const met = rule.test(value)
                return (
                    <li key={rule.key} className={met ? 'met' : ''}>
                        <FiCheck size={14} />
                        {rule.label}
                    </li>
                )
            })}
        </ul>
    )
}

export default PasswordChecklist
